import { ModalBackdrop } from "./ModalBackdrop";
import { IcoClose, IcoTrash } from "./icons";

interface ConfirmDialogProps {
  title: string;
  message?: string;
  body?: React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
  busy?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export function ConfirmDialog({
  title,
  message,
  body,
  confirmLabel = "Удалить",
  cancelLabel = "Отмена",
  danger = true,
  busy,
  onConfirm,
  onClose,
}: ConfirmDialogProps) {
  return (
    <ModalBackdrop onClose={onClose}>
      <div
        className="modal modal-narrow"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-label={title}
      >
        <div className="modal-head">
          {danger && (
            <div className="launch-dot" style={{ background: "#FEE4E2" }}>
              <IcoTrash size={12} stroke="#DC2626" />
            </div>
          )}
          <h2>{title}</h2>
          <div className="spacer" />
          <button
            type="button"
            className="modal-close"
            onClick={onClose}
            disabled={busy}
            aria-label="Закрыть"
          >
            <IcoClose size={16} />
          </button>
        </div>
        <div className="modal-body">
          {message && (
            <p style={{ margin: 0, fontSize: 13, color: "var(--text-2)", lineHeight: 1.5 }}>
              {message}
            </p>
          )}
          {body}
        </div>
        <div className="modal-foot">
          <div className="spacer" />
          <button type="button" className="btn-ghost" onClick={onClose} disabled={busy}>
            {cancelLabel}
          </button>
          <button
            type="button"
            className="btn-primary"
            style={
              danger
                ? {
                    background: "#DC2626",
                    boxShadow: "0 1px 2px rgba(220,38,38,0.25)",
                  }
                : undefined
            }
            onClick={onConfirm}
            disabled={busy}
          >
            {busy ? "Удаляем…" : confirmLabel}
          </button>
        </div>
      </div>
    </ModalBackdrop>
  );
}
